export const API_KEY_STATUSES = ["active", "revoked"] as const;
export type ApiKeyStatus = (typeof API_KEY_STATUSES)[number];

/** Named accessors for API key statuses — use instead of string literals. */
export const API_KEY_STATUS = {
  ACTIVE: "active",
  REVOKED: "revoked",
} as const satisfies Record<string, ApiKeyStatus>;

export const API_KEY_CONSTANTS = {
  /** Identifiable prefix (secret-scanning friendly, Stripe/GitHub style) */
  KEY_PREFIX: "ak_live_",
  /** Random bytes of entropy per key (192 bits) */
  KEY_RANDOM_BYTES: 24,
  /** Characters of the key stored for masked display */
  DISPLAY_PREFIX_LENGTH: 12,
  /** Maximum simultaneously active keys per creator */
  MAX_ACTIVE_KEYS_PER_CREATOR: 5,
} as const;

export interface ApiKey {
  id: string;
  creatorId: string;
  name: string;
  keyPrefix: string;
  last4: string;
  status: ApiKeyStatus;
  rateLimitPerMinute: number;
  rateLimitPerDay: number;
  lastUsedAt?: Date | null;
  lastUsedIp?: string | null;
  expiresAt?: Date | null;
  revokedAt?: Date | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface ApiKeyUsageLog {
  id: string;
  apiKeyId: string;
  creatorId: string;
  requestId?: string | null;
  endpoint: string;
  method: string;
  statusCode: number;
  ip?: string | null;
  userAgent?: string | null;
  responseTimeMs?: number | null;
  createdAt: Date;
}

/** Input shape for recording one public-API request in the usage log. */
export interface ApiKeyUsageLogInput {
  apiKeyId: string;
  creatorId: string;
  requestId?: string | null;
  endpoint: string;
  method: string;
  statusCode: number;
  ip?: string | null;
  userAgent?: string | null;
  responseTimeMs?: number | null;
}
